import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Modal from 'components/base/Modal';
import { campaignPath } from 'app/routes';
import Confirm from 'app/components/Confirm';
import { selectCampaign, CampaignTypeList, CampaignTypes, FEATURE_RELEASE_DATE, DIALER_NEW_BADGE_EXPIRATION_DAYS } from 'data/campaigns';
import { selectProfile, getMarketingUrl, selectListManagementEnabled, selectUserId } from 'data/user';
import { openLeadAutomatorUpgrade } from 'data/user/actions';
import { getBrandRedirectMessage } from 'utils/brand';
import SVG from 'components/base/SVG';
import { checkContactsPropertyAssociation, createDialerCampaign } from '../../../data/user/actions';
import { createDirectMailCampaign } from 'data/campaigns/actions';
import { getMarketingProfile } from "data/user/actions";
import css from './style.scss';
import NoEligibleLeads from '../../AccountNew/modals/NoEligibleLeads';
import cssModal from "../../../app/AccountNew/style.scss";
import LeadAutomatorUpgrade from '../../../components/DialerCampaign/LeadAutomatorUpgrade/LeadAutomatorUpgrade';
import FullAccessRequiredModal from "components/ClickToDial/FullAccessRequiredModal/FullAccessRequiredModal";
import { handleDialerEligibility } from './DialerEligibility';
import CampaignActivitySettingsModal from 'app/Campaigns/CampaignActivitySettingsModal';
import InfoAlert from 'app/components/InfoAlert';
import { isPropStream } from 'utils/brand';

import { isLegacyAccountPlan } from "data/user/selectors";
import LeaveMessagePopup from "../../../app/AccountNew/modals/LeaveMessage";
import CreateDirectMailHandler from "./DirectMail/CreateDirectMailHandler";

// Dialer "New!" badge Visible for 90 days from PROD release date

const isDialerFeatureNew = () => {
  const expirationDate = new Date(FEATURE_RELEASE_DATE);
  expirationDate.setDate(
    expirationDate.getDate() + DIALER_NEW_BADGE_EXPIRATION_DAYS
  );
  return new Date() < expirationDate;
};

class ActivityPopup extends PureComponent {
  state = {
    isCheckingEligibility: false,
    showNoEligibleLeads: false,
    showModal: false,
    pendingActivityType: null,
    pendingContactIds: null,
    showActivityPopup: true,
  };
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleModalSave = this.handleModalSave.bind(this);
  }

  handleClose() {
    const { campaign, history } = this.props;

    history.push(campaignPath(campaign ? campaign.get('id') : null));
  }

  getIconForType = (type) => {
    if (type.code === CampaignTypes.DIALER.code) {
      return 'iconDialer';
    } else if (type.code === CampaignTypes.POSTCARD.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.DIRECTMAIL.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.EMAIL.code) {
      return 'iconEmail';
    }
    return null;
  };


  handleDialerClick = (e, cardUrl) => {
    if (this.props.profile?.get?.("type") === 'TEAM') {
      this.props.openFullAccessRequiredModal({onClose: this.props.closeFullAccessRequiredModal});
      return;
    }

    if (this.state.isCheckingEligibility) return;

    if (this.props.isLegacyAccount && !this.props.hasLeadAutomator) {
      this.handleClose();
    }

    handleDialerEligibility({
      campaign: this.props.campaign,
      hasLeadAutomator: this.props.hasLeadAutomator,
      isLegacyAccount: this.props.isLegacyAccount,
      leaveMessagePopup: this.props.leaveMessagePopup,
      openLeadAutomatorUpgrade: this.props.openLeadAutomatorUpgrade,
      checkContactsPropertyAssociation: this.props.checkContactsPropertyAssociation,
      createDialerCampaign: this.props.createDialerCampaign,
      history: this.props.history,
      setState: this.setState.bind(this),
      onEligible: (contactIds) => {
        this.setState({
          showModal: true,
          pendingActivityType: 'DIALER',
          pendingContactIds: contactIds,
          showActivityPopup: false
        });
      },
    });
  };
  
  handleDirectMailClick = async (e, cardUrl) => {
    const handler = new CreateDirectMailHandler(this.props.userId, this.props.campaign.toJS(), null,
      this.props.createDirectMailCampaign, this.props.getMarketingProfile);
    const campaign = await handler.run();

    this.props.history.push({pathname: cardUrl, state: {isNewCampaign: true, newCampaign: campaign}});
  };

  handleCardKeyDown = (e, onActivate) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onActivate();
    }
  };

  handleClick = (type, url, e) => {
    const { confirm } = this.props;

    if (url) {
      if (e && e.preventDefault) e.preventDefault();

      confirm({
        question: getBrandRedirectMessage(url),
        okLabel: 'Continue',
        onOk: () => {
          // 👉 AFTER confirm → open your modal
          this.setState({
            showModal: true,
            showActivityPopup: false,
            pendingActivityType: type.code.toUpperCase(),
            pendingUrl: url,
            pendingType: type,
          });
        },
      });
    }
  };

  handleModalSave(name) {
    const marketingCampaignId = this.props.campaign.get('id');
    const { pendingActivityType, pendingContactIds } = this.state;

    if (pendingActivityType === 'DIALER') {
      const contactIds = pendingContactIds;

      this.props.createDialerCampaign({
        name,
        marketingCampaignId,
        contactIds,
        originatingListName: this.props.campaign.get('name'),
      })
        .then((res) => {
          this.setState({
            showModal: false,
            pendingActivityType: null,
            pendingContactIds: null,
          });

          this.props.history.push(`/campaign/${marketingCampaignId}/dialer/${res.id}`);
        })
        .catch((err) => {
          this.setState({
            showModal: false,
            pendingActivityType: null,
            pendingContactIds: null,
          });
          this.props.history.push(campaignPath(marketingCampaignId));
        });
    }

    if (pendingActivityType === 'POSTCARD') {
      const { campaign } = this.props;
      const marketingCampaignId = campaign.get('id');

      const cardUrl = campaignPath(`${marketingCampaignId}/postcard`);

      this.setState({ showModal: false, pendingActivityType: null, pendingUrl: null, pendingType: null },
        () => {
          this.props.history.push(cardUrl, { name });
        }
      );
    }

    if (pendingActivityType === 'EMAIL') {
      const { campaign } = this.props;
      const cardUrl = campaignPath(`${campaign.get('id')}/email`);
      this.setState({ showModal: false, pendingActivityType: null }, () => {
        this.props.history.push(cardUrl, { activityName: name });
      });
    }
  }

  render() {
    const { campaign, profile } = this.props;

    return (
      <>
        <Modal isOpen={this.state.showActivityPopup} isCloseButton uniqId="ActivityPopup" width="628px" padding="20px 40px 40px" modalClassName={css.activityModal} onClose={this.handleClose}>
          <div className={css.activityModalTitle}>Add New Activity</div>
          <div className={css.activitiesInner}>
            {CampaignTypeList.filter(type => type.enabled).map((type) => {
              const url = getMarketingUrl(profile, type);
              const isDialer = type.code === CampaignTypes.DIALER.code;
              const isEmail = type.code === CampaignTypes.EMAIL.code;
              const cardUrl = !url ? campaignPath(`${campaign.get('id')}/${type.route}`) : null;
            // Not showing Dialer Campaign for Whitelabel accounts
            if (isDialer && !isPropStream()) {
              return;
            }
            return (
              <div className={css.activityCard} key={type.code}>
                {isDialer && isDialerFeatureNew() && (
                  <div className={css.newBadge}>New!</div>
                )}
                  {cardUrl ? (
                    isDialer ? (
                      <div className={css.activityLink} onClick={(e) => this.handleDialerClick(e, cardUrl)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => this.handleCardKeyDown(e, () => this.handleDialerClick(e, cardUrl))}
                        style={{ cursor: 'pointer' }}>
                        <div className={css.iconWrapper}>
                          <SVG icon="iconCircleBackground" className={css.circleBackground} />
                          <div className={css.iconInner}>
                            <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                          </div>
                        </div>
                        <div className={css.activityTitle}>
                          {type.title}
                        </div>
                      </div>
                    ) : isEmail ? (
                      <div className={css.activityLink}
                        onClick={() => this.setState({ showModal: true, pendingActivityType: 'EMAIL', showActivityPopup: false })}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => this.handleCardKeyDown(e, () => this.setState({ showModal: true, pendingActivityType: 'EMAIL', showActivityPopup: false }))}
                        style={{ cursor: 'pointer' }}>
                        <div className={css.iconWrapper}>
                          <SVG icon="iconCircleBackground" className={css.circleBackground} />
                          <div className={css.iconInner}>
                            <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                          </div>
                        </div>
                        <div className={css.activityTitle}> {type.title} </div>
                      </div>
                    ) : (
                      <div className={css.activityLink} onClick={(e) => this.handleDirectMailClick(e, cardUrl)} style={{ cursor: 'pointer' }}>
                        <div className={css.iconWrapper}>
                          <SVG icon="iconCircleBackground" className={css.circleBackground} />
                          <div className={css.iconInner}>
                            <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                          </div>
                        </div>
                        <div className={css.activityTitle}>{type.title}</div>
                      </div>
                    )
                  ) : (
                    <div
                      className={css.activityLink}
                      onClick={(e) => this.handleClick(type, url, e)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => this.handleCardKeyDown(e, () => this.handleClick(type, url, e))}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className={css.iconWrapper}>
                        <SVG icon="iconCircleBackground" className={css.circleBackground} />
                        <div className={css.iconInner}>
                          <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                        </div>
                      </div>
                      <div className={css.activityTitle}>{type.title}</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <LeadAutomatorUpgrade onUpgrade={this.handleClose} />
          <div className={cssModal.clsIntegrationCard}>
            <NoEligibleLeads
              isOpen={this.state.showNoEligibleLeads}
              onClose={() => this.setState({ showNoEligibleLeads: false })}
              onConfirm={() => this.setState({ showNoEligibleLeads: false })}
            />
          </div>

        </Modal>
        <CampaignActivitySettingsModal
          isOpen={this.state.showModal}
          onClose={() =>
            this.setState({
              showModal: false,
              showActivityPopup: true
            })
          }
          activityType={this.state.pendingActivityType}
          context="CAMPAIGN_TAB"
          campaignId={this.props.campaign.get('id')}
          onSave={this.handleModalSave}
          customClassName={css.activityCustomModal}
        />
      </>
    );
  }
}

export default withRouter(connect((state) => ({
  campaign: selectCampaign(state),
  profile: selectProfile(state),
  userId: selectUserId(state),
  hasLeadAutomator: selectListManagementEnabled(state),
  isLegacyAccount: isLegacyAccountPlan(state),
}), {
  confirm: Confirm.open,
  openLeadAutomatorUpgrade,
  checkContactsPropertyAssociation,
  createDialerCampaign,
  createDirectMailCampaign,
  getMarketingProfile,
  showAlert: InfoAlert.open,
  leaveMessagePopup: LeaveMessagePopup.open,
  openFullAccessRequiredModal: FullAccessRequiredModal.open,
  closeFullAccessRequiredModal: FullAccessRequiredModal.close,
  leaveMessagePopup: LeaveMessagePopup.open,
})(ActivityPopup));
